var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlacemarkOrange(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "28px",
    viewBox: "0 0 20 28",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "placemark-purple") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "placemark-purple",
    fill: "#FFA800",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,0 C4.47937,0 0,4.03188 0,9 C0,17 10,28 10,28 C10,28 20,17 20,9 C20,4.03188 15.5206,0 10,0 Z M9.99999906,13.9999991 C9.20887,13.9999991 8.43552,13.7654 7.77772,13.3259 C7.11992,12.8864 6.60723,12.2616 6.30448,11.5307 C6.00173,10.7998 5.92252,9.99556 6.07686,9.21964 C6.2312,8.44372 6.61216,7.73098 7.17157,7.17157 C7.73098,6.61216 8.44372,6.2312 9.21964,6.07686 C9.99556,5.92252 10.7998,6.00173 11.5307,6.30448 C12.2616,6.60723 12.8864,7.11992 13.3259,7.77772 C13.7654,8.43552 13.9999991,9.20887 13.9999991,9.99999906 C13.9988,11.0605 13.577,12.0773 12.8271,12.8271 C12.0773,13.577 11.0605,13.9988 9.99999906,13.9999991 Z",
    id: "Shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlacemarkOrange);
export default __webpack_public_path__ + "static/media/placemark-orange.0f0acdd286d42503d3c5b7dd1b9617d8.svg";
export { ForwardRef as ReactComponent };